import React, { Component } from 'react';
import * as pt from 'prop-types';

import DatePicker from 'react-datepicker';
import moment from 'moment';

class DateFilters extends Component {
    constructor (props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange (type, value) {
        var data = {};
        data[type] = value;
        this.props.onChange(data);
    }

    render () {
        let filters = this.props.filters;

        let start = moment.isMoment(filters.startDateTime) ?
            filters.startDateTime :
            moment(filters.startDateTime)
        ;

        let stop = moment.isMoment(filters.stopDateTime) ?
            filters.stopDateTime :
            moment(filters.stopDateTime)
        ;
        
        return (
          <>
            <div className='input-group'>
              <span className='input-group-addon'>Start</span>
              <DatePicker
                disabled={this.props.disabled}
                fixedHeight={true}
                showYearDropdown
                showMonthDropdown
                peekNextMonth
                className='form-control'
                dateFormat='MM/DD/YYYY'
                selected={start}
                onChange={this.handleChange.bind(null, 'startDateTime')}
                maxDate={stop}
                PopoverProps={{
                  disablePortal: true,
                }}
              />
            </div>
            <div className='input-group'>
              <span className='input-group-addon'>End</span>
              <DatePicker
                disabled={this.props.disabled}
                fixedHeight={true}
                showYearDropdown
                showMonthDropdown
                peekNextMonth
                className='form-control'
                dateFormat='MM/DD/YYYY'
                selected={stop}
                onChange={this.handleChange.bind(null, 'stopDateTime')}
                minDate={start}
                PopoverProps={{
                  disablePortal: true,
                }}
              />
            </div>
          </>
        )
    }
}

DateFilters.propTypes = {
    filters: pt.object,
    onChange: pt.func,
    disabled: pt.bool
};

export default DateFilters;
